// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1810":"8e7e84f0","5665":"050dcc24","9948":"0231d687"}[chunkId] + ".chunk.css";
};